import React from "react";
import {Link} from "gatsby"
const TableFooter = ({ item }) => {
    return (
        <td>
            {item? <Link to={item} className="btn">Get Started</Link>:null}  
        </td>
    );
};

export default TableFooter;